import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { when } from "@/lib/rides";
import { MapView } from "@/components/MapView";
import { Brand } from "@/components/Brand";
import { FOLLOW_COPY } from "@/components/FollowRide";

const STATUS = { ...FOLLOW_COPY, confirmed: "RIDE CONFIRMED", completed: "RIDE COMPLETE", cancelled: "RIDE CANCELLED" };

export default function TrackRide() {
  const { token } = useParams();
  const { data, error, isLoading } = useQuery({ queryKey: ["track", token], queryFn: () => api.get(`/track/${token}`).then((r) => r.data), refetchInterval: 15000, retry: false });
  if (isLoading) return <div className="grid h-screen place-items-center"><Loader2 className="h-6 w-6 animate-spin" /></div>;
  if (error || !data) {
    return (
      <div className="grid h-screen place-items-center p-6 text-center" data-testid="track-expired">
        <div><Brand to="/" /><p className="mt-6 font-display text-2xl font-bold">THIS RIDE TRACKING LINK HAS EXPIRED</p></div>
      </div>
    );
  }
  return (
    <div data-testid="track-page">
      <MapView pickup={data.pickup} dropoff={data.dropoff} driver={data.driver_location} route={data.driver_route} />
      <div className="fixed inset-x-0 bottom-0 z-[500] p-3 sm:left-4 sm:right-auto sm:top-4 sm:bottom-auto sm:w-96">
        <div className="space-y-3 rounded-3xl border bg-card/95 p-5 backdrop-blur-xl">
          <Brand to="/" />
          <p className="font-display text-xl font-bold" data-testid="track-status">{STATUS[data.status] || data.status.toUpperCase()}</p>
          {data.sharing && data.eta_minutes && <p className="text-sm" data-testid="track-eta">ETA: {data.eta_minutes} minutes</p>}
          <div className="text-sm"><p><span className="text-muted-foreground">Pickup:</span> {data.pickup.name}</p><p><span className="text-muted-foreground">Destination:</span> {data.dropoff.name}</p></div>
          {data.driver_first_name && <p className="text-sm" data-testid="track-driver">Driver: {data.driver_first_name}{data.vehicle ? ` · ${data.vehicle}` : ""}</p>}
          <p className="text-xs text-muted-foreground">{data.sharing ? "Live location updates every few seconds." : "Live location shows while the driver is on the way."} Link expires {when(data.expires_at)}.</p>
        </div>
      </div>
    </div>
  );
}
